import React from 'react';
import { Box, Button, Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

/**
 * A oferta de assinatura no instante em que o lançamento termina.
 *
 * ELA FICA DEPOIS DO RESULTADO, e não antes. Quem acabou de fechar um mês veio
 * ver o número, não o preço: empurrar a oferta para o topo empurraria o
 * Índice de Saúde para baixo da dobra no exato momento em que ele é a resposta.
 * Aqui ela é o que a pessoa encontra ao terminar de ler.
 *
 * Card, e não Snackbar nem Dialog: ela não interrompe, não cobre nada e sai com
 * um clique. E o "Agora não" existe porque oferta sem saída vira armadilha —
 * numa tela que a pessoa vai visitar todo mês, isso azeda rápido.
 *
 * A lógica (quem vê, o que entra em cada lista, preço) mora em
 * `planosApresentacao.ofertaAoConcluirLancamento`, com teste. Aqui é só desenho.
 */
const OfertaAoConcluir = ({ oferta, aoVerPlanos, aoDispensar }) => {
  if (!oferta) return null;

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider' }}>
      <CardContent>
        <Typography variant="subtitle1" component="h2">{oferta.titulo}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: '65ch' }}>
          {oferta.frase}
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 3 }}
          divider={<Divider flexItem orientation="vertical" sx={{ display: { xs: 'none', md: 'block' } }} />}
          sx={{ mt: 2.5 }}
        >
          {/* O QUE JÁ É DELE VEM PRIMEIRO, e vem inteiro. Uma oferta que começa
              pelo que falta ensina o usuário que o produto dele é uma amostra. */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="overline" color="text.secondary">
              Continua seu, de graça
            </Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {oferta.jaTem.map((item) => (
                <Stack key={item} direction="row" spacing={1} alignItems="flex-start">
                  <CheckCircleOutlineIcon fontSize="small" color="success" sx={{ mt: 0.25 }} />
                  <Typography variant="body2" sx={{ maxWidth: '45ch' }}>{item}</Typography>
                </Stack>
              ))}
            </Stack>
            {oferta.notaDoGratuito && (
              <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1.5, maxWidth: '45ch' }}>
                {oferta.notaDoGratuito}
              </Typography>
            )}
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="overline" color="text.secondary">
              O que a assinatura acrescenta
            </Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {oferta.ganha.map((item) => (
                <Stack key={item} direction="row" spacing={1} alignItems="flex-start">
                  <AddCircleOutlineIcon fontSize="small" color="primary" sx={{ mt: 0.25 }} />
                  <Typography variant="body2" sx={{ maxWidth: '45ch' }}>{item}</Typography>
                </Stack>
              ))}
            </Stack>
            {/* Preço sem periodicidade é preço pela metade: R$ 497 uma vez e
                R$ 497 por mês são produtos diferentes. */}
            <Typography variant="subtitle2" sx={{ mt: 1.5 }}>
              {oferta.plano.nome} — {oferta.plano.preco}
              {oferta.plano.periodicidade ? ` ${oferta.plano.periodicidade}` : ''}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ mt: 2.5 }} flexWrap="wrap" useFlexGap>
          <Button variant="contained" onClick={aoVerPlanos} sx={{ minHeight: 44 }}>
            Ver o que muda
          </Button>
          <Button onClick={aoDispensar} sx={{ minHeight: 44 }}>Agora não</Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default OfertaAoConcluir;
